var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product.id)?_c('admin-product-view',{attrs:{"product":_vm.product}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }